import { Exception } from "./exception";

export class ForbiddenException extends Exception {
}
